import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useTemplateVariablesStore } from '../stores/TemplateVariablesStore'
import { useSystemParamsStore } from '../stores/SystemParamsStore'

export function useAppInitialization() {
  const isAppReady = ref(false)
  const router = useRouter()
  const templateStore = useTemplateVariablesStore()
  const { fetchTemplateData } = templateStore
  const systemParamsStore = useSystemParamsStore()

  const initializeApp = async () => {
    // Wait for the router to finish its initial navigation so currentRoute is resolved
    await router.isReady()
    const currentRoute = router.currentRoute.value
    const requiresAuth = currentRoute.meta?.requiresAuth
    // Only load template variables for authenticated routes
    if (requiresAuth) {
      await Promise.all([
        fetchTemplateData(),
        systemParamsStore.loadLargeGroupCutoff(),
      ])
    }    
    isAppReady.value = true
  }

  return {
    isAppReady,
    initializeApp
  }
} 